// TO DEFINE THE STATES AND CHANGE STATUS
import { createSlice } from '@reduxjs/toolkit';
import { fetchBreak, fetchBreaksByShiftId } from './breaksThunks';

const initialState = {
  break: [],
  breaks: [],
  selectedShiftId: null,
  status: 'idle',
  error: null,
};

const breaksSlice = createSlice({
  name: 'breaks',
  initialState,
  reducers: {
    setSelectedShiftId: (state, action) => {
      state.selectedShiftId = action.payload;
    },
    setSelectedPeriod: (state, action) => {
      state.period = action.payload;
    },
    clearBreaks: (state) => {
      state.breaks = [];
    },
    setBreaks: (state, action) => {
      state.breaks = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBreak.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchBreak.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.break = action.payload;
      })
      .addCase(fetchBreak.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      .addCase(fetchBreaksByShiftId.pending, (state) => {
        state.status = 'loading';
        state.breaks = []; // Clear the breaks array when fetching new breaks
      })
      .addCase(fetchBreaksByShiftId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.breaks = action.payload;
      })
      .addCase(fetchBreaksByShiftId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { setSelectedShiftId, setSelectedPeriod, clearBreaks, setBreaks } = breaksSlice.actions;

export const selectSelectedBreak = (state) => state.breaks.break;
export const selectAllBreaksByShiftId = (state) => state.breaks.breaks;
export const selectShiftId = (state) => state.breaks.selectedShiftId;
export const selectBreaksStatus = (state) => state.breaks.status;

export default breaksSlice.reducer;
